export const tokens = {
  colors: {
    primary: "#3E8150",
    background: "#FAFBFB",
    surface: "#FFFFFF",
    textMain: "#2B4233",
    textMuted: "#5C7864",
    accent: "#2C6B40",
    error: "#C64A4A",
    activeBackground: "#E3EEE3",
    pillGlow: "#C9E4C9",
    infoToast: "#3F84C7",
  },
  colorsDark: {
    primary: "#46955C",
    background: "#161B17",
    surface: "#232A25",
    textMain: "#EEF4EF",
    textMuted: "#9DB2A4",
    accent: "#5FB070",
    error: "#E57A7A",
    activeBackground: "#2B332D",
    pillGlow: "#38463C",
    infoToast: "#6FA8DC",
  },
  spacing: {
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32,
  },
  radius: {
    card: 16,
    // Soft-rounded inputs matching the Claude Design language (was 28px pills).
    input: 13,
    button: 999,
    image: 12,
  },
  shadows: {
    soft: "0 4px 18px rgba(43, 66, 51, 0.18)",
    float: "0 14px 38px rgba(35, 60, 42, 0.22)",
  },
  typography: {
    headingFamily:
      '"Plus Jakarta Sans", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    bodyFamily:
      '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    headingWeight: 700,
    bodyWeightRegular: 400,
    bodyWeightBold: 600,
    sizes: {
      displayLarge: 32,
      titleLarge: 24,
      titleMedium: 20,
      bodyLarge: 15,
      bodyMedium: 14,
      bodySmall: 13,
      labelLarge: 13,
      labelMedium: 12,
      labelSmall: 11,
    },
  },
  breakpoints: {
    mobile: 600,
    tablet: 1024,
  },
  // Public inquiry form (/i/{slug}) — its own visual identity per the Claude
  // Design spec: sage-on-cool-white, Cormorant Garamond display + Hanken
  // Grotesk body. Consumed by buildInquiryTheme() the same way buildTheme()
  // consumes `colors` above. Light mode only.
  inquiryForm: {
    colors: {
      accent: "#3E8150",
      accentDeep: "#2C5E3A",
      accentSoft: "#E9F1EB",
      sage: "#8FB39B",
      bg: "#EEF3EF",
      surface: "#FFFFFF",
      ink: "#1E2A23",
      muted: "#6E7C73",
      line: "#E3EAE4",
      error: "#C24A3A",
      errorSoft: "#F7E5E1",
      warnBg: "#FBF3E2",
      warnBorder: "#EAD9B0",
      warnText: "#7A5A12",
      pausedBg: "#FAF0DC",
      pausedText: "#9A6B1E",
    },
    radius: {
      input: 13,
      card: 16,
      button: 15,
      pill: 999,
    },
    typography: {
      displayFamily:
        '"Cormorant Garamond", Georgia, "Times New Roman", serif',
      bodyFamily:
        '"Hanken Grotesk", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    },
    layout: {
      // The reading-column width. The form is mobile-first; on wider screens the
      // chrome bars stay full-bleed but their content (and the step body) centre
      // to this column so desktop doesn't stretch the single-column flow.
      maxWidth: 640,
    },
  },
} as const;

export type Tokens = typeof tokens;
